import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_dashboard/layout/core';
import { ThemesListWrapper } from './themes-list/ThemesList';
import { useIntl } from 'react-intl';

const ThemesPage = () => {
  const intl = useIntl(); 

  const ThemesBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'themes_PAGE.BREADCRUMB' }), 
      path: '/apps/themes-management/themes',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='themes'
          element={
            <>
              <PageTitle breadcrumbs={ThemesBreadcrumbs}>
                {intl.formatMessage({ id: 'THEMES_PAGE.TITLE' })}
              </PageTitle>
              <ThemesListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/themes-management/themes' />} />
    </Routes>
  );
};

export default ThemesPage;